import { useSearchParams } from "react-router-dom";

export function useSetTaskAndIteration() {
  const [searchParams, setSearchParams] = useSearchParams();

  return (taskId, iteration, index=0) => {
    searchParams.set("taskid", String(taskId ?? 0));
    searchParams.set("iteration", String(iteration ?? 0));
    searchParams.set("index", String(index ?? 0));
    setSearchParams(searchParams, { replace: true });
  };
}